<template>
  <el-container v-loading="loading" class="system-count" :class="returnClass()">
    <micro-app name="SystemCount" :url="systemCountUrl" :data="data" @created="created"></micro-app>
  </el-container>
</template>
<script>
import hostMap from "@/micro/config"
import microApp from "@micro-zoe/micro-app"
import { mapState } from "vuex"
import { microAppSetData } from "@/micro/micro-app-utils"

export default {
  name: "SystemCount",
  data() {
    return {
      data: { from: "9005来自基座的初始化数据" },
      systemCountUrl: hostMap("//localhost:9005/"),
      loading: false
    }
  },
  computed: {
    ...mapState("user", ["nowSys"]),
    ...mapState("tagsView", ["visitedViews", "nowClickActionType"])
  },
  watch: {
    "$route.name"(n) {
      if (n === "SystemCount") {
        const path = location.hash
        setTimeout(() => {
          if (path && path === "#/count/drivePage") {
            // 发送数刷新数据
            microApp.forceSetData("SystemCount", { type: "rest", data: true })
            this.loading = true
            setTimeout(() => {
              this.loading = false
            }, 1500)
          }
        }, 500)
      }
    }
  },
  methods: {
    // 在拖动收藏菜单时，因为数据中心有iframe，导致拖动无效，需要做以下动作
    returnClass() {
      if (this.nowSys) {
        return "pointer-events_none"
      }
    },
    changeData() {
      this.data = { from: "来自基座的数据" + +new Date() }
    },

    created() {
      // 主要是进来驾驶舱首页，给加载框
      const path = location.hash
      if (path && path === "#/count/drivePage") {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 1000)
      }
      // 解决保活状态下，关闭最后一个页面，再次打开还有缓存的问题
      if (this.visitedViews.filter(item => item.sysBelong === "/count").length === 1 && this.nowClickActionType === "") {
        setTimeout(() => {
          microAppSetData("SystemCount", { type: "reload", data: Math.random() })
        }, 50)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.system-count {
  height: 100%;
}
.pointer-events_none {
  pointer-events: none;
}
</style>
